<div class="number_of_records_container" cdkScrollable>
  <span class="body2-impaired">{{ 'MAT_PAGINATOR.NUMBER_OF_RECORDS' | translate }} </span>
  <app-select-impaired [optionListWidth]="81" (selectValueChanged)="pageSizeChangedSelect($event)" [selectOptions]="pageSizeList" [selectValue]="pageSizeOption">
    <app-button-icon
      [buttonName]="pageSizeOption.title"
    ></app-button-icon>

  </app-select-impaired>
</div>

<span class="body2-impaired">
  {{ 'MAT_PAGINATOR.NUMBER_RECORDS' | translate }}: {{ currentCount }} {{ allCount && allCount !== currentCount ? 'из ' + allCount : '' }}
</span>

<div class="number_of_page_container">
  <app-impaired-icon [isIconDisabled]="!hasPrevFirstPage" (clickOnIcon)="prevPage(null)" [iconName]="icons.FirstPageImpaired"></app-impaired-icon>
  <app-impaired-icon [isIconDisabled]="!hasPrevPage" (clickOnIcon)="prevPage(1)" [iconName]="icons.PrevPageImpaired"></app-impaired-icon>
  <input
    [disabled]="pageSize === -1 || (hasPrevFirstPage && hasLastPage)"
    (keypress)="numberOnly($event)"
    (focusout)="setInput()"
    type="number"
    (keydown.enter)="pageIndexChange()"
    (click)="clearInput()"
    name="pageIndex"
    [(ngModel)]="pageIndex"
    class="body2-impaired number_of_page"
  />
  <app-impaired-icon [isIconDisabled]="!hasNextPage" (clickOnIcon)="nextPage(1)" [iconName]="icons.NextPageImpaired"></app-impaired-icon>
  <app-impaired-icon [isIconDisabled]="!hasLastPage" (clickOnIcon)="nextPage(null)" [iconName]="icons.LastPageImpaired"></app-impaired-icon>
</div>
